@if (team && !team.isActive()) {
    <span class="badge bg-danger flex-shrink-0 align-self-center"
          [ngClass]="badgeClass"
          [adaptTooltip]="hasActiveChildren
              ? 'This group is no longer active in the organisation.<br>It is shown because there are active child groups located within it.'
              : 'This group is no longer active in the organisation.'"
          [adaptTooltipIsHtml]="true"
          data-test="ended-team-badge">
        <i class="fal fa-exclamation-circle"></i>
        Inactive
    </span>
}
